import { useDispatch, useSelector } from 'react-redux';
import FocusMenu from '../../../core/components/FocusMenu';
import UserGroupPermissions from '../../../core/components/UserGroupPermissions';
import { viewPermissionRefs } from '../../../core/components/UserGroupPermissions';
import { selectReclamationDamageOptions } from '../../reclamations/reducer';
import { getDamageClaimOptions, updateDamageClaimOptions } from '../../reclamations/actions';
import { useEffect } from 'react';

const DamageOptions = () => {
  const damageOptions = useSelector(selectReclamationDamageOptions);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDamageClaimOptions());
  }, []);
  return (
    <UserGroupPermissions itemRef={viewPermissionRefs.damage}>
      <FocusMenu
        data={damageOptions}
        parentLabelKey="value"
        childLabelKey="value"
        childKey="options"
        onSubmit={(output) => {
          dispatch(updateDamageClaimOptions(output));
        }}
      />
    </UserGroupPermissions>
  );
};

export default DamageOptions;
